import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink,useHistory } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
	Card,
	CardContent,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
//cookies
import {get_cookies} from "../../../components/Cookies/Cookies";
import LoadingModal from "../../../components/Modal/LoadingModal";
import numeral from "numeral";
import LoginMessageBox from "../../../components/MessageBox/LoginMessageBox";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const AccountUpgradePayment = () => {
	  let history = useHistory();
	const [uniqueID, setUniqueId] = useState('');
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();
	
	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));
	const [inputValue, setInputValue] = useState('');
		const [showModal, setShowModal] = useState(false);
		 const [showMsgBox, setShowMsgBox] = useState(false);
		   const [msgBoxContent, setMsg] = useState("empty");
		   const [msgType, setMsgType] = useState("success");
	// console.log(uniqueID);
	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        await axios.get(
			process.env.REACT_APP_API_URL+'table_data_payment', {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: useridNo,
				unique_id: uniqueID
            }
        }).then((res)=>{
             
			setPosts(res.data.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		})
		setDataLoaded(true);
    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "reference_no",
			label: "Referenc No",
		},
		{
			name: "date_created",
			label: "Date Upgraded",
		},
		{
			name: "idno",
			label: "ID No",
		},
		{
			name: "fullname",
			label: "Name",
		},
		// {
		// 	name: "old_country",
		// 	label: "From Country",
		// },
		{
			name: "old_atype",
			label: "Past Account Type",
		},
		// {
		// 	name: "new_country",
		// 	label: "To Country",
		// },
		{
			name: "new_atype",
			label: "Current Account ype",
		},
		{
			name: "action",
			label: "Action",
			options: {
				download: false, //exclude this column in csv export
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let id =  posts[dataIndex].id;
					let status =  posts[dataIndex].status;
					// collectionviewdetails
					// collectionallocat
						return(
							<Grid container spacing={1}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
									{get_cookies('can_process') == 1 ?
										<NavLink to={"/sales/account-upgrade-payment-view/"+id+"/"+useridNo}>
											<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
												View
											</Button>	
										</NavLink> 
											:null}
									</Grid>
							</Grid>
						)
                                        }
			},
	 	}
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		download: false,  //add this
		print: false, //add this
		viewColumns :false,
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		downloadOptions: {
			filename : 'CollectionTransactionHistory.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	const handleSubmit= async () => {
		setShowModal(true);
		 await axios
		      .get(process.env.REACT_APP_API_URL + "fetch_reference", {
			params: {
			  reference_no: inputValue,
			  jc_u_idno: get_cookies("branchidno"),
			  curcode: get_cookies("curcode"),
			},
		      })
		      .then((res) => {
			if(res.data.data == null){
				setShowModal(false);
				setShowMsgBox(true);
				setMsg("No results found for your search.");
				setMsgType("warning");
				setTimeout(() => {
				  setShowMsgBox(false);
				}, 2500);
			}else if(res.data.data.date_paid !== "0000-00-00"){
				setShowModal(false);
				setShowMsgBox(true);
				setMsg("Account Upgrade has been already paid");
				setMsgType("warning");
				setTimeout(() => {
				  setShowMsgBox(false);
				}, 2500);
			}else if(res.data.data.main_reference_no !== inputValue && res.data.data.main_reference_no != ""){
				setShowModal(false);
				setShowMsgBox(true);
				setMsg("Account Upgrade has Mutiple Account Please use Main Reference No");
				setMsgType("warning");
				setTimeout(() => {
				  setShowMsgBox(false);
				}, 2500);
			}else{
				let main_reference_no = res.data.data.main_reference_no!= ""?res.data.data.main_reference_no :0;
				setShowModal(false);
				history.push(`/sales/account-upgrade-payment-view/${main_reference_no}/${res.data.data.id}/${useridNo}`);
			}
		
			// setPackage(res.data.countrytag_package[0]);
			// setItems(res.data.countrytag_packagesitem);
			// setSoInfo(res.data.distributor_info);
			// setUpgDetails(res.data.countrytag_upgrade_details);
			// setShipping(res.data.countrytag_shipping);
			// setGrandTotal(parseFloat(res.data.countrytag_shipping[0].shipping_fee) + parseFloat(res.data.countrytag_upgrade_details.amount));
			// // setWarehouse(res.data.get_location);
			// console.log('??',res.data.countrytag_shipping);
			// if (res.data.is_released.is_released == 0) {
			//   setIsReleased(true);
			// } else {
			//   setIsReleased(false);
			// }
			// getWarehouse();
		
			// setPayments(res.data.data.customer_alloc);
			// if (res.data.data.order_details) {
			//   setShowPdf(true);
			// }
			//total_payment = res.data.data.cp_payments+res.data.data.b1t1_payments+res.data.data.ppv_payments+res.data.data.dragonpay_payments+res.data.data.paypanda_payments+res.data.data.asiapay_payments+res.data.data.ipay_payments;
		      })
		      .catch((error) => {
			// console.log(error.message);
		      });
	      };
	    

	return (
		<div className="page">
					<LoadingModal showModal={showModal}/>

			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/WholesaleMenu">
						<h2 className="header-title">Wholesale</h2>
					</NavLink>  
					<Typography color="textPrimary">Account Upgrade</Typography>
				</Breadcrumbs>

			</div>
			<div className="page-container">
			<div style={{ display: 'flex',  justifyContent: 'center', alignItems: 'center', }}>
			<LoginMessageBox
						    in={showMsgBox}
						    content={msgBoxContent}
						    type={msgType}
						  />
      <Card style={{ width:800, padding: 20 }}>
        <CardContent>
          <Typography variant="h6" align="center" gutterBottom>
	  Please Enter Reference Number
          </Typography>
          <TextField
            fullWidth
            label="Reference Number"
            variant="outlined"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            style={{ marginBottom: 20 }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </CardContent>
      </Card>
    </div>
				{/* <div style={style}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
							<Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
								<TextField 
									id="outlined-search" 
									label="Search by ID" 
									type="search" 
									variant="outlined" 
									value={uniqueID}
									onChange={e => {
										setUniqueId(e.target.value);
									}}
								/>
                            </Grid>
                            <Grid item xs={4} lg={1} xl={1}>
                                <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                            </Grid>
                        </Grid>        
                    </div> */}

				{/* {!dataLoaded ? (
					<Preloader />
				) : (
						<MUIDataTable
							title={
								<div>
									<h3 className="header-title" style ={{color: "#339933"}}>
									Account Upgrade
									</h3>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
				)} */}
			</div>
		</div>
	);
};

export default AccountUpgradePayment;